export default __webpack_public_path__ + "static/media/plus.a5d9714a.svg";